import { ComponentIds, ConnectionUtils, ConnectorsComponent, ConnectorType, HierarchyUtils, PointConnector, Transform, TransformUtils, Vector, } from "@inter-ikea-core/core";
import { NO_UPRIGHTS } from "../constants/errors";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getDescendingMountingRails } from "../utils/getEntityData";
import { getSectionUprightsByUpright, getUprights, } from "../utils/sectionsHelpers";
import { ALIGN_MOUNTING_RAIL_TO_UPRIGHT_RIGHT, ALIGN_UPRIGHT_TO_MOUNTING_RAIL, } from "../constants/connectorKeys";
import { getConnectorsComponent } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
import { CHILD_IS_ORPHAN, CONNECTOR_DOESNT_EXISTS, } from "@inter-ikea-storagetwo/range/dist/constants/errors";
import { BACK_WALL, FRONT_WALL, } from "@inter-ikea-storagetwo/range/dist/constants/connectorKeys";
export const getInsertPossibleAlignments = (guest, host) => {
    const mountingRail = HierarchyUtils.parent(host);
    if (!mountingRail)
        throw new Error(CHILD_IS_ORPHAN);
    const wall = HierarchyUtils.parent(mountingRail);
    if (!wall)
        throw new Error(CHILD_IS_ORPHAN);
    const mountingRails = HierarchyUtils.descendants(wall).filter((entity) => entity.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT));
    return ConnectionUtils.matchingAlignmentConnections(guest, mountingRails);
};
export const getRootMountingRail = (entity) => {
    const parentEntity = HierarchyUtils.parent(entity);
    if (!parentEntity)
        return;
    if (entity.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT) &&
        !parentEntity.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT)) {
        return entity;
    }
    return getRootMountingRail(parentEntity);
};
export const getOppositeSideCorrespondingConnector = (connectorKey, upright) => {
    const host = Object.values(getSectionUprightsByUpright(upright)).find((u) => (u === null || u === void 0 ? void 0 : u.id) !== upright.id);
    const hostConnector = host
        .getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)
        .getConnectorByKey(connectorKey);
    if (!hostConnector)
        throw new Error(CONNECTOR_DOESNT_EXISTS);
    return { host, hostConnector };
};
export const adjustMergeAlignmentConnector = (entity) => {
    var _a, _b, _c, _d, _e, _f;
    // Retrieve last and first mounting rails and their uprights.
    const lastMountingRail = getDescendingMountingRails(entity).at(-1);
    const firstMountingRail = getRootMountingRail(entity);
    if (!lastMountingRail || !firstMountingRail)
        return;
    const lastUprightTransform = ((_a = getUprights(lastMountingRail)) === null || _a === void 0 ? void 0 : _a.rightUpright) &&
        TransformUtils.worldTransform(getUprights(lastMountingRail).rightUpright);
    const firstRightUprightTransform = ((_b = getUprights(firstMountingRail)) === null || _b === void 0 ? void 0 : _b.rightUpright) &&
        TransformUtils.worldTransform(getUprights(firstMountingRail).rightUpright);
    if (!lastUprightTransform || !firstRightUprightTransform)
        return;
    // Remove any old alignment that exists.
    const updatedConnectors = (_c = getConnectorsComponent(firstMountingRail)) === null || _c === void 0 ? void 0 : _c.connectors.filter((connector) => connector.key !== ALIGN_MOUNTING_RAIL_TO_UPRIGHT_RIGHT);
    const rightUpright = (_d = getUprights(firstMountingRail)) === null || _d === void 0 ? void 0 : _d.rightUpright;
    if (!rightUpright)
        throw new Error(NO_UPRIGHTS);
    // Create new alignment connector.
    const uprightTransform = TransformUtils.localTransform(rightUpright);
    const newConnector = new PointConnector(ALIGN_MOUNTING_RAIL_TO_UPRIGHT_RIGHT, ConnectorType.ALIGNMENT, new Transform(new Vector(uprightTransform.position.X, 5, uprightTransform.position.Z)), 1, 100, true, undefined, [ALIGN_MOUNTING_RAIL_TO_UPRIGHT_RIGHT], [ALIGN_UPRIGHT_TO_MOUNTING_RAIL]);
    const wallName = (_f = (_e = HierarchyUtils.parent(firstMountingRail)) === null || _e === void 0 ? void 0 : _e.getComponent(ComponentIds.DISPLAY_NAME_COMPONENT_ID)) === null || _f === void 0 ? void 0 : _f.name;
    // Determine the width adjustment based on the wall configuration (X or Z axis) and move connector accordingly.
    const adjustmentSum = wallName === BACK_WALL || wallName === FRONT_WALL
        ? Math.abs(lastUprightTransform.position.X -
            firstRightUprightTransform.position.X)
        : Math.abs(lastUprightTransform.position.Z -
            firstRightUprightTransform.position.Z);
    const adjustedConnector = newConnector.move(new Vector(adjustmentSum + 20, 0, 0));
    updatedConnectors.push(adjustedConnector);
    // Update the first mounting rail with the adjusted connectors
    firstMountingRail.addComponent(new ConnectorsComponent(updatedConnectors));
};
